import { useEffect, useState } from 'react';
import DocFileViewer from './DocFileViewer';
import { documentsApi, fetchDocFileObjectUrl, downloadDocFile } from '../utils/api';

// A ledger's scan in the full-screen viewer, opened from the Suppliers page /
// supplier page without leaving it. Owns what DocumentViewPage owns there:
// loading the document's files and the authenticated blob URL per page.
export default function LedgerViewer({ docId, onClose }) {
  const [files, setFiles]     = useState(null);   // null = loading
  const [pageIdx, setPageIdx] = useState(0);
  const [url, setUrl]         = useState('');
  const [failed, setFailed]   = useState(false);

  useEffect(() => {
    let cancelled = false;
    documentsApi.getOne(docId).then(({ data }) => {
      if (cancelled) return;
      const list = data?.files?.length > 0
        ? data.files
        : (data?.file_path ? [{ file_path: data.file_path, page_number: 1 }] : []);
      setFiles(list);
      if (list.length === 0) setFailed(true);
    }).catch((err) => {
      console.error('[ledger-viewer]', err);
      if (!cancelled) { setFiles([]); setFailed(true); }
    });
    return () => { cancelled = true; };
  }, [docId]);

  const fp = files?.[Math.min(pageIdx, (files?.length || 1) - 1)]?.file_path;
  useEffect(() => {
    if (!fp) return undefined;
    let cancelled = false;
    let created = '';
    setUrl('');
    fetchDocFileObjectUrl(fp).then((u) => {
      if (cancelled) { if (u?.startsWith('blob:')) URL.revokeObjectURL(u); return; }
      created = u?.startsWith('blob:') ? u : '';
      setUrl(u || '');
    }).catch((err) => {
      console.error('[ledger-viewer] file', err);
      if (!cancelled) setFailed(true);
    });
    return () => { cancelled = true; if (created) URL.revokeObjectURL(created); };
  }, [fp]);

  if (failed) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 360 }}>
          <p style={{ margin: '0 0 16px' }}>לא ניתן להציג את סריקת הכרטסת.</p>
          <button type="button" className="btn btn-primary" onClick={onClose}>סגור</button>
        </div>
      </div>
    );
  }
  if (!files) return null;

  return (
    <DocFileViewer
      variant="fullscreen"
      files={files}
      pageIdx={pageIdx}
      onPageChange={setPageIdx}
      url={url}
      onClose={onClose}
      onDownload={() => files.forEach((f, i) => setTimeout(() => downloadDocFile(f.file_path), i * 250))}
      offerNativeViewer={typeof window !== 'undefined' && window.innerWidth <= 1024}
    />
  );
}
